<template>
  <ErrorPage />
</template>

<script setup>
import ErrorPage from "~/components/ErrorPage.vue";

definePageMeta({
  layout: "custom",
});
</script>

<style lang="scss" scoped></style>
